export const CompanyPaths = {
	Index: {
		route: "/company",
		path: "/company",
	},
	Detail: {
		route: "/company/:id/detail",
		path: (id: number) => `/company/${id}/detail`,
	},
	Create: {
		route: "/company/create",
		path: () => "/company/create",
	},
};
